import { h } from 'preact'
import { ForwardFn, forwardRef } from 'preact/compat'
import cls from 'classnames'

import classes from '../components/TextInputComp/index.scss'
import { TextInputCompProps } from '../components/TextInputComp/type'

const TextInput: ForwardFn<TextInputCompProps, HTMLInputElement> = (props, ref) => {
  const { value, onChange, placeholder, className } = props

  const handleChange = (evt: any) => {
    onChange(evt.target.value)
  }

  return (
    <input
      ref={ref}
      className={cls(classes.input, className)}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
    />
  )
}

export default forwardRef(TextInput)
